import { Component, OnInit } from '@angular/core';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  public isAuthenticated = false;
  public authConfig!: AuthConfig;

  public ngOnInit(): void {
    this.isAuthenticated = this.authService.isAuthenticated();
    this.authConfig = this.authService.getAuthConfig();
  }

  constructor(private authService: AuthService) { }
}